import { render, staticRenderFns } from "./AlertsSuspiciousTraffic.vue?vue&type=template&id=7f19b100&scoped=true&"
import script from "./AlertsSuspiciousTraffic.vue?vue&type=script&lang=js&"
export * from "./AlertsSuspiciousTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f19b100",
  null
  
)

export default component.exports